module.exports = __webpack_public_path__ + "static/media/erro_feedback.cbc8724a.svg";